import { Component } from 'react'

import { connect } from 'react-redux'
import { get } from 'lodash'
import { Row, Col } from 'react-bootstrap'
import SideNav from 'components/side-nav'
import StoreBreadcrumb from '../store-breadcrumb'
import PageAnimation from 'components/page-animation'

export class ContentContainer extends Component {
  render() {
    let activeSlugSet = get(this.props, 'location.state.slugSet')
    if (!activeSlugSet && get(this.props, 'params.categorySlug')) {
      activeSlugSet =
        this.props.categories[this.props.params.categorySlug].slugSet
    }
    if (!activeSlugSet) {
      activeSlugSet = []
    }
    return (
      <div>
        <StoreBreadcrumb activeSlugSet={activeSlugSet} className="hidden-xs" />
        <Row className="mbl">
          <Col sm={3} className="hidden-xs">
            <SideNav
              activeSlugSet={activeSlugSet}
              categoryTree={this.props.categoryTree}
              sidebarTitle={'Categories'}
            />
          </Col>
          <Col sm={9}>
            <div style={{ position: 'relative' }}>
              <PageAnimation>
                <div
                  key={this.props.params ? this.props.params.categorySlug : ''}
                >
                  {this.props.children}
                </div>
              </PageAnimation>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.categories,
    categoryTree: state.categoryTree,
  }
}

export default connect(mapStateToProps)(ContentContainer)
